function _(n,o,t){var u=n(270);t.CustomJS=u.CustomJS;var a=n(272);t.OpenURL=a.OpenURL}
//# sourceMappingURL=index.min.js.map